"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bannerForm = _interopRequireDefault(require("../components/bannerForm"));
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    bannerForm: _bannerForm.default
  },
  data: function data() {
    return {
      banner: {
        img: '',
        jumpType: '',
        jumpUrl: '',
        goods: {}
      }
    };
  },
  methods: {}
};
exports.default = _default;